import React from 'react';
import { Button } from '@fragments';
import Popover from '../Popover';

// Small building blocks of the inspector bar, all on the Button fragment.
export function Toggle({ icon: Icon, label, active, onClick, disabled }) {
  return <Button size="small" variant="text" color="overlay" preventLoading icon={<Icon />} className={active ? 'is-active' : ''} aria-pressed={!!active}
    aria-label={label} tooltip={label} disabled={disabled} onClick={onClick} />;
}

export function Action({ icon: Icon, label, onClick, disabled, variant = 'text' }) {
  return <Button size="small" variant={variant} color="overlay" preventLoading icon={<Icon />} aria-label={label} tooltip={label} disabled={disabled} onClick={onClick} />;
}

// An icon button that opens a popover of controls (spacing, effects, position…).
export function PopoverAction({ icon: Icon, label, children, width = 280, disabled }) {
  return <Popover label={label} width={width} placement="top" disabled={disabled} dock
    trigger={<Button size="small" variant="text" color="overlay" preventLoading icon={<Icon />} aria-label={label} tooltip={label} disabled={disabled} />}>
    {children}
  </Popover>;
}

export const Divider = ({ className = '' }) => <span className={`art-inspector__divider ${className}`} aria-hidden="true" />;
